import { useAppSelector } from "../stores/hooks";
import PennText from "@/components/ui/text/PennText";
import PennLink from "@/components/ui/link/PennLink";
import { TOKEN_STORAGE_KEY } from "../config/auth-storage-keys";
import { authStorage } from "../config/session-storage";

export const NotFoundPage = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const jwtToken = authStorage.getItem(TOKEN_STORAGE_KEY);
  const isLoggedIn = isAuthenticated || !!jwtToken;

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <PennText as="h1" size="2xl" align="center" color="on-navy" font="semibold" className="text-8xl mb-4">
          404
        </PennText>
        <PennText as="h2" size="xl" align="center" color="on-navy" font="semibold" className="mb-2">
          Page not found
        </PennText>
        <PennText as="p" size="base" align="center" color="on-navy-secondary" className="mb-8">
          The page you are looking for doesn't exist or has been moved.
        </PennText>
        <PennLink
          to={isLoggedIn ? "/" : "/login"}
          size="sm"
          font="semibold"
          className="px-6 py-3 rounded-2xl bg-penn-500 text-white hover:bg-penn-700 hover:text-white transition-colors"
        >
          {isLoggedIn ? "Back to Home" : "Back to Login"}
        </PennLink>
      </div>
    </div>
  );
};
